// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1Scfq","left":"StickyBox_left__Rc88I","right":"StickyBox_right__1Dedv"};